import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthDialog from "@/components/AuthDialog";
import ScrollToTop from "@/components/ScrollToTop";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import CareerAI from "@/pages/CareerAI";
import Roadmaps from "@/pages/Roadmaps";
import RoadmapDetail from "@/pages/RoadmapDetail";
import Ebooks from "@/pages/Ebooks";
import Playbooks from "@/pages/Playbooks";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/career-ai" element={<CareerAI />} />
      <Route path="/roadmaps" element={<Roadmaps />} />
      <Route path="/roadmaps/real-estate-finance" element={<Navigate to="/roadmaps/real-estate" replace />} />
      <Route path="/roadmaps/:slug" element={<RoadmapDetail />} />
      <Route path="/ebooks" element={<Ebooks />} />
      <Route path="/playbooks" element={<Playbooks />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/dashboard" element={<Dashboard />} />
      {/* Private admin surface — intentionally NOT linked from any public page,
          NOT in the navbar/footer, and gated server-side. The URL alone is not
          security; every /api/admin/* endpoint is protected by require_admin. */}
      <Route path="/vantstride-admin-console" element={<AdminDashboard />} />
      <Route path="/privacy" element={<Legal slug="privacy" />} />
      <Route path="/terms" element={<Legal slug="terms" />} />
      <Route path="/refund-policy" element={<Legal slug="refund-policy" />} />
      <Route path="/copyright-and-intellectual-property" element={<Legal slug="copyright-ip" />} />
      <Route path="/affiliate-disclosure" element={<Legal slug="affiliate-disclosure" />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Navbar />
          <main>
            <AppRoutes />
          </main>
          <Footer />
          <AuthDialog />
          <Toaster richColors position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
